import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

const LoginCallback = () => {
    const navigate = useNavigate();
    const { instance } = useMsal();

    useEffect(() => {
        const handleRedirect = async () => {
            try {
                await instance.handleRedirectPromise();
                navigate('/dashboard');
            } catch (error) {
                console.error('Error handling redirect:', error);
                navigate('/signin');
            }
        };

        handleRedirect();
    }, [instance, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Completing sign-in...</p>
        </div>
    );
};

export default LoginCallback;
